// @flow
import axios from 'lib/defaultClient';

export type WriteCommentPayload = {
  brandId: string,
  text: string,
  replyTo?: ?string,
};

export const writeComment = ({ brandId, text, replyTo }: WriteCommentPayload) =>
  axios.post(`/brands/${brandId}/comments`, {
    text,
    reply_to: replyTo,
  });

export type ReadCommentsPayload = {
  brandId: string,
};

export const readComments = ({ brandId }: ReadCommentsPayload) =>
  axios.get(`/brands/${brandId}/comments`);

export type ReadSubCommentsPayload = {
  brandId: string,
  commentId: string,
  parentId?: ?string,
};

export const readSubComments = ({ brandId, commentId }: ReadSubCommentsPayload) =>
  axios.get(`/brands/${brandId}/comments/${commentId}/replies`);

export type RemoveCommentPayload = {
  brandId: string,
  commentId: string,
};

export const removeComment = ({ brandId, commentId }: RemoveCommentPayload) => {
  return axios.delete(`/brands/${brandId}/comments/${commentId}`);
};

export type EditCommentPayload = {
  brandId: string,
  commentId: string,
  text: string,
  parentId: ?string,
};

export const editComment = ({ brandId, commentId, text }: EditCommentPayload) =>
  axios.patch(`/brands/${brandId}/comments/${commentId}`, { text });



// WEBPACK FOOTER //
// ./src/lib/api/brands/comments.js